const core = "@livepeer/core@3.3.1";
const react = "@livepeer/react@4.3.4";

export const version = {
  core,
  react,
} as const;
